import * as React from "react";
const SvgGiftvoucher = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14 7.332a.667.667 0 0 0 .667-.667V4A.667.667 0 0 0 14 3.332H2a.667.667 0 0 0-.667.667v2.666c0 .369.299.667.667.667a.667.667 0 0 1 0 1.333.667.667 0 0 0-.667.667v2.667c0 .368.299.666.667.666h12a.667.667 0 0 0 .667-.666V9.332A.667.667 0 0 0 14 8.665a.667.667 0 1 1 0-1.333Zm-8-.667a.667.667 0 0 0-.667.667v1.333a.667.667 0 1 0 1.334 0V7.332A.667.667 0 0 0 6 6.665ZM12.016 8a2 2 0 0 1 1.317-1.88V4.665H6.667a.667.667 0 0 1-1.334 0H2.667V6.12a2 2 0 0 1 0 3.76v1.453h2.666a.667.667 0 1 1 1.334 0h6.666V9.879a2 2 0 0 1-1.317-1.88Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGiftvoucher;
